
<v-img
    v-if="imageX"
    :src="imageX"
    max-height="700"
    aspect-ratio="1.0"
    :contain="image"
>
</v-img>
